<template>
  <div id="info">
    <!-- <div class="hero-bg">
      <div class="hero">
        <div class="hero-title">
          精准发音，全球对话<br />
          <span class="blue">晓A精灵，你的AI英语专家</span>
        </div>
        <div class="hero-desc">
          发音要准，进步要狠，未来要稳
        </div>
      </div>
    </div> -->
    <div class="about-row">
      <div class="about-left">
        <div class="about-title">关于我们</div>
        <div class="about-desc">
          湖南果精灵科技有限公司是以AI技术为核心的英语教育创新品牌，专注于学生的英语能力提升。通过自主研发的智能学习系统，我们正在重新定义英语教育的新标准，赋能未来英语学习。
        </div>
        <div class="about-title1">我们致力于</div>
        <ul class="about-list">
          <li>让每个学生获得个性化、高效的学习体验</li>
          <li>帮助中国学生既赢在考场，又赢在未来</li>
          <li>通过科技推动教育公平化与国际化</li>
        </ul>
      </div>
      <div class="about-right"><!-- 图片站位 --></div>
    </div>
    <div class="advantage-bg">
      <div class="advantage-section">
        <div class="advantage-title">我们的独特优势</div>
        <div class="advantage-txt">
          晓A精灵正在用技术创新，让优质英语教育触手可及。
        </div>
        <div class="advantage-cards">
          <div class="advantage-card">
            <div class="icon icon1"></div>
            <div class="advantage-card-title">智能学习引擎</div>
            <div class="advantage-card-desc">
              0.5秒全维学习诊断+自适应学习算法，精准提升学习效率
            </div>
          </div>
          <div class="advantage-card">
            <div class="icon icon2"></div>
            <div class="advantage-card-title">双轨课程体系</div>
            <div class="advantage-card-desc">
              同步国内课标要求与国际标准，培养全球胜任力
            </div>
          </div>
          <div class="advantage-card">
            <div class="icon icon3"></div>
            <div class="advantage-card-title">海量教学资源</div>
            <div class="advantage-card-desc">
              微课程、情景对话、海量题库，满足多样化学习需求
            </div>
          </div>
          <div class="advantage-card">
            <div class="icon icon4"></div>
            <div class="advantage-card-title">科学训练系统</div>
            <div class="advantage-card-desc">
              "测→练→学→测一评"，让进步可视化、效果可衡量
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="why-section">
      <div class="why-title">为什么选择我们？</div>
      <div class="why-cols">
        <div class="why-col">
          <div class="why-col-title">技术基因</div>
          <div class="why-col-list">
            <div class="why-col-list-item">
              <span class="icon icon5"></span>
              <div>
                <div class="txt1">创始团队</div>
                <div class="txt2">教育科技专家+一线教师联合研发</div>
              </div>
            </div>
            <div class="why-col-list-item">
              <span class="icon icon6"></span>
              <div>
                <div class="txt1">核心技术</div>
                <div class="txt2">0.5秒全维学习诊断、自适应学习系统</div>
              </div>
            </div>
          </div>
        </div>
        <div class="why-col">
          <div class="why-col-title">解决方案</div>
          <div class="why-col-list">
            <div class="why-col-list-item">
              <span class="logo">✔</span>
              <div>
                <div class="txt1">智能学习系统</div>
                <div class="txt2">个性化诊断+精准训练</div>
              </div>
            </div>
            <div class="why-col-list-item">
              <span class="logo">✔</span>
              <div>
                <div class="txt1">双轨课程</div>
                <div class="txt2">同步国内课标与国际标准</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="promise-bg">
      <div class="promise-section">
        <div class="promise-title">我们的承诺</div>
        <div class="promise-txt">
          我们是一个充满教育理想的新锐团队，致力于通过技术创新让优质英语教育触手可及。
        </div>
        <div class="promise-cards">
          <div class="promise-card">
            <div class="icon icon7"></div>
            <div class="promise-card-title">真实可信</div>
            <div class="promise-card-desc">所有教学成果将基于实际数据呈现</div>
          </div>
          <div class="promise-card">
            <div class="icon icon8"></div>
            <div class="promise-card-title">科学验证</div>
            <div class="promise-card-desc">
              所有教学效果描述均有技术原理支撑
            </div>
          </div>
          <div class="promise-card">
            <div class="icon icon9"></div>
            <div class="promise-card-title">持续迭代</div>
            <div class="promise-card-desc">
              所有功能升级均通过版本更新说明公开
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.advantage-card,.promise-card {
  cursor: pointer;
  &:hover {
    transform: scale(1.02);
  }
}
#info {
  color: #9a212a;
  padding-top: 60px;
  background: #ffffff;
  .hero-bg {
    background: #F4D9D7;
  }
  .hero {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0 60px 0;
    text-align: center;
    .hero-title {
      font-size: 38px;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 12px;
    }
    .blue {
      color: #9a212a;
    }
    .hero-desc {
      color: #9a212a;
      font-size: 16px;
      margin-bottom: 8px;
    }
  }
  .about-row {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 60px;
    .about-left {
      flex: 1;
      padding-right: 40px;
      .about-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .about-title1 {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .about-desc {
        font-size: 16px;
        color: #9a212a;
        margin-bottom: 18px;
        line-height: 1.8;
      }
      .about-list {
        margin-bottom: 0;
        padding-left: 28px;
        li {
          position: relative;
          list-style-type: none;
          font-size: 16px;
          color: #9a212a;
          margin-bottom: 8px;
          &::before {
            line-height: 16px;
            font-size: 8px;
            text-align: center;
            border-radius: 50%;
            background: #22c55e;
            width: 16px;
            height: 16px;
            color: #ffffff;
            content: "✔";
            position: absolute;
            left: -26px;
            font-weight: 600;
          }
        }
      }
    }
    .about-right {
      width: 50%;
      height: 380px;
      border-radius: 8px;
      // box-shadow: 0 4px 24px #e5eaf3;
      background-image: url(../assets/new-page/hone/img1.png);
      background-size: 100% 100%;
    }
  }
  .advantage-bg {
    background: #F4D9D7;
    .advantage-section {
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 60px 0;
      .advantage-title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
      }
      .advantage-txt {
        text-align: center;
        font-size: 16px;
        color: #9a212a;
        margin: 10px 0 60px;
      }
      .advantage-cards {
        display: flex;
        gap: 24px;
        .advantage-card {
          flex: 1;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px #e5eaf3;
          padding: 32px 18px;
          .icon {
            width: 48px;
            height: 48px;
            margin-bottom: 10px;
          }
          .icon1 {
            background-image: url(../assets/new-page/info/icon1.png);
            background-size: 100% 100%;
          }
          .icon2 {
            background-image: url(../assets/new-page/info/icon2.png);
            background-size: 100% 100%;
          }
          .icon3 {
            background-image: url(../assets/new-page/info/icon3.png);
            background-size: 100% 100%;
          }
          .icon4 {
            background-image: url(../assets/new-page/info/icon4.png);
            background-size: 100% 100%;
          }

          .advantage-card-title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .advantage-card-desc {
            font-size: 15px;
            color: #9a212a;
          }
        }
      }
    }
  }

  .why-section {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0 60px 0;
    .why-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 60px;
    }
    .why-cols {
      display: flex;
      gap: 48px;
      justify-content: center;
      .why-col {
        flex: 1;
        min-width: 320px;
        .why-col-title {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .why-col-list {
          line-height: 2;
          .why-col-list-item {
            display: flex;
            .icon {
              margin-right: 10px;
              width: 50px;
              height: 50px;
            }
            .logo {
              margin-right: 10px;
              color: #22c55e;
            }
            .icon5 {
              background-image: url(../assets/new-page/info/icon5.png);
              background-size: 100% 100%;
            }
            .icon6 {
              background-image: url(../assets/new-page/info/icon6.png);
              background-size: 100% 100%;
            }
            .txt1 {
              font-size: 16px;
            }
            .txt2 {
              color: #9a212a;
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .promise-bg {
    background: #F4D9D7;
    .promise-section {
      width: 1200px;
      margin: 0 auto;
      padding: 48px 0 80px;
      .promise-title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
      }
      .promise-txt {
        text-align: center;
        font-size: 16px;
        color: #9a212a;
        margin: 10px 0 60px;
      }
      .promise-cards {
        display: flex;
        gap: 24px;
        .promise-card {
          flex: 1;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px #e5eaf3;
          padding: 32px 30px;
          .icon {
            width: 48px;
            height: 48px;
            margin-bottom: 10px;
          }
          .icon7 {
            background-image: url(../assets/new-page/info/icon7.png);
            background-size: 100% 100%;
          }
          .icon8 {
            background-image: url(../assets/new-page/info/icon8.png);
            background-size: 100% 100%;
          }
          .icon9 {
            background-image: url(../assets/new-page/info/icon9.png);
            background-size: 100% 100%;
          }
          .promise-card-title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .promise-card-desc {
            font-size: 15px;
            color: #9a212a;
          }
        }
      }
    }
  }
}
</style>
